import React, { useState, useEffect } from 'react';
import { Table, Button, Badge, Spinner, Alert, Card, Image } from 'react-bootstrap';
import * as adminApi from '../../Services/adminApi';
import { getImageUrl } from '../../utils/imageUtils';
import Swal from 'sweetalert2';

const ModerationQueue = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchQueue = async () => {
        try {
            setLoading(true);
            const data = await adminApi.getModerationQueue();
            setListings(data);
        } catch (err) {
            setError('Napaka pri nalaganju vrste za moderacijo.');
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchQueue();
    }, []);

    const handleResolve = async (listingId, decision, title) => {
        const actionText = decision === 'approve' ? 'odobriti' : 'zavrniti';
        const confirmButtonColor = decision === 'approve' ? '#28a745' : '#dc3545';

        const result = await Swal.fire({
            title: `Ali ste prepričani?`,
            text: `Želite ${actionText} oglas: ${title}?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Da, potrdi',
            cancelButtonText: 'Prekliči',
            confirmButtonColor: confirmButtonColor
        });

        if (result.isConfirmed) {
            try {
                await adminApi.resolveModeration(listingId, decision);
                Swal.fire('Uspešno!', `Oglas je bil ${decision === 'approve' ? 'odobren' : 'zavrnjen'}.`, 'success');
                fetchQueue(); // Osveži seznam
            } catch (err) {
                Swal.fire('Napaka!', err.message, 'error');
            }
        }
    };

    if (loading) return <div className="text-center mt-5"><Spinner animation="border" /></div>;

    return (
        <div className="p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Moderacija oglasov</h2>
                <Badge bg="info">{listings.length} čakajočih</Badge>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {listings.length === 0 ? (
                <Alert variant="success">Trenutno ni oglasov, ki bi potrebovali ročni pregled. Dobro delo!</Alert>
            ) : (
                <Table responsive hover className="shadow-sm bg-white rounded">
                    <thead className="bg-light">
                        <tr>
                            <th>Slika</th>
                            <th>Podrobnosti oglasa</th>
                            <th>Prodajalec & Kršitve</th>
                            <th>AI Razlog zavrnitve</th>
                            <th className="text-end">Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {listings.map((ad) => (
                            <tr key={ad.id} style={{ verticalAlign: 'middle' }}>
                                <td style={{ width: '120px' }}>
                                    <Image
                                        src={getImageUrl(ad.images?.find(img => img.is_primary)?.image_url, 'card')}
                                        rounded
                                        style={{ width: '100px', height: '70px', objectFit: 'cover' }}
                                    />
                                </td>
                                <td>
                                    <div className="fw-bold">{ad.title}</div>
                                    <div className="text-muted small" style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                        {ad.description}
                                    </div>
                                    <Badge bg="secondary">{ad.category?.name}</Badge>
                                    <div className="mt-1 fw-bold text-primary">{ad.price} €</div>
                                </td>
                                <td>
                                    <div>{ad.seller?.username}</div>
                                    <div className="small text-muted">{ad.seller?.email}</div>
                                    <Badge bg={ad.seller?.safety_violations_count >= 2 ? 'danger' : 'warning'} text="dark">
                                        Kršitve: {ad.seller?.safety_violations_count}
                                    </Badge>
                                    {ad.seller?.status === 'suspendiran' && (
                                        <div className="text-danger x-small fw-bold">UPORABNIK BANNAN</div>
                                    )}
                                </td>
                                <td style={{ maxWidth: '250px' }}>
                                    <div className="p-2 border rounded bg-light small italic">
                                        <i className="fas fa-robot me-1 text-muted"></i>
                                        {ad.ai_moderation_reason || 'AI ni podal specifičnega razloga.'}
                                    </div>
                                </td>
                                <td className="text-end">
                                    <div className="d-flex flex-column gap-2 align-items-end">
                                        <Button
                                            variant="success"
                                            size="sm"
                                            className="w-100"
                                            onClick={() => handleResolve(ad.id, 'approve', ad.title)}
                                        >
                                            <i className="fas fa-check me-1"></i> Odobri
                                        </Button>
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            className="w-100"
                                            onClick={() => handleResolve(ad.id, 'reject', ad.title)}
                                        >
                                            <i className="fas fa-times me-1"></i> Zavrni
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}
        </div>
    );
};

export default ModerationQueue;